export const iconFontAwesomePhotosImagesFilm = (
	<i className="fa-solid fa-film"></i>
);
